import {inject, Injectable} from '@angular/core';
import {RecordCalendarFilesApiService} from "../services-api/record-calendar-files-api.service";
import {AttachFileToRecord, RecordCalendarFileParams, GetFilesDataParams} from "../types/file.types";

@Injectable({
  providedIn: 'root'
})
export class RecordCalendarFilesService {
  private recordCalendarFilesApiService: RecordCalendarFilesApiService = inject(RecordCalendarFilesApiService);

  public getFilesData(getFilesDataParams: GetFilesDataParams): Promise<Array<RecordCalendarFileParams>> {
    return new Promise<Array<RecordCalendarFileParams>>((resolve, reject) => {
      this.recordCalendarFilesApiService.getFilesData(getFilesDataParams).subscribe({
        next: (filesData: Array<RecordCalendarFileParams>) => resolve(filesData),
        error:(error) => reject(error)
      });
    });
  }

  public attachFileToRecord(attachFileToRecord: AttachFileToRecord): Promise<RecordCalendarFileParams> {
    return new Promise((resolve, reject) => {
      this.recordCalendarFilesApiService.attachFileToRecord(attachFileToRecord).subscribe({
        next: (recordCalendarFileParams: RecordCalendarFileParams) => resolve(recordCalendarFileParams),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFileToRecord(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.recordCalendarFilesApiService.deleteFileToRecord(id).subscribe({
        next: resolve,
        error: (error) => reject(error)
      });
    });
  }
}
